import RelatedDocumentsDraggable from './RelatedDocumentsDraggable'

export default RelatedDocumentsDraggable



// WEBPACK FOOTER //
// ./src/modules/RelatedDocuments/RelatedDocumentsDraggable/index.js